import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-cookie-consent',
  standalone: false,
  templateUrl: './cookie-consent.html',
  styleUrl: './cookie-consent.css'
})
export class CookieConsent implements OnInit {
  showBanner = true;

  private readonly COOKIE_CONSENT_KEY = 'horseloop_cookie_consent';

  ngOnInit() {
    this.checkConsent();
  }

  checkConsent() {
    try {
      const consent = localStorage.getItem(this.COOKIE_CONSENT_KEY);
      this.showBanner = !consent;
    } catch (e) {
      this.showBanner = true;
    }
  }

  acceptAll() {
    this.saveConsent('all');
  }

  acceptNecessary() {
    this.saveConsent('necessary');
  }

  private saveConsent(type: string) {
    const consent = {
      type: type,
      timestamp: new Date().toISOString()
    };
    localStorage.setItem(this.COOKIE_CONSENT_KEY, JSON.stringify(consent));
    this.showBanner = false;
  }
}
